import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useResetCareerBankLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (jobSourceId: number) => {
      const csrfToken =
        (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';
      const response = await fetch('/admin/api/assistant_todos/reset_career_bank_login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ job_source_id: jobSourceId }),
      });
      if (!response.ok) {
        throw new Error('同期対象に戻せませんでした');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'assistant_todos'] });
    },
  });
}
